import Notification, { FlashMessageType, INotification } from './Notification';

export { FlashMessageType };
export type { INotification };

export default Notification;
